// Do not modify this file by hand!
// Re-generate this file by running lit-localize.
/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en-GB`;
/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
    `ar-SA`,
    `da-DK`,
    `de-DE`,
    `en-IE`,
    `en-US`,
    `es-ES`,
    `fr-FR`,
    `fr-MA`,
    `is-IS`,
    `it-IT`,
    `ms-MY`,
    `nb-NO`,
    `pl-PL`,
    `pt-PT`,
    `sv-SE`,
    `th-TH`,
    `tr-TR`,
    `zh-CN`,
    `zh-HK`,
];
/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
    `ar-SA`,
    `da-DK`,
    `de-DE`,
    `en-GB`,
    `en-IE`,
    `en-US`,
    `es-ES`,
    `fr-FR`,
    `fr-MA`,
    `is-IS`,
    `it-IT`,
    `ms-MY`,
    `nb-NO`,
    `pl-PL`,
    `pt-PT`,
    `sv-SE`,
    `th-TH`,
    `tr-TR`,
    `zh-CN`,
    `zh-HK`,
];
